"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Events that should be fired by step plugins.
 */
var FacadeEvents;
(function (FacadeEvents) {
    FacadeEvents["RENDER"] = "render";
    FacadeEvents["DESTROY"] = "destroy";
})(FacadeEvents = exports.FacadeEvents || (exports.FacadeEvents = {}));
